/**
 * Login Component (TypeScript)
 * Automatically redirects to Cognito for authentication
 */

import React, { useEffect } from 'react';

const Login: React.FC = () => {
  useEffect(() => {
    // In production, use relative URL since frontend and backend are on same domain
    // In development, use the configured API URL
    const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production' ||
                        process.env.NODE_ENV === 'production';
    const apiUrl = isProduction ? '' : (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || '');
    
    // Redirect to backend AppRunner service for OIDC login
    // The backend handles the authentication flow with Cognito
    const loginUrl = `${apiUrl}/login`;
    console.log('Redirecting to Cognito login:', loginUrl);
    
    // Automatically redirect to login
    window.location.href = loginUrl;
  }, []);

  const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production' ||
                       process.env.NODE_ENV === 'production';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting to login...</p>
        {!isProduction && !process.env.REACT_APP_API_URL && !process.env.REACT_APP_API_BASE_URL && (
          <p className="mt-2 text-red-600 text-sm">
            Error: Backend API URL not configured
          </p>
        )}
      </div>
    </div>
  );
};

export default Login;